// extracted by mini-css-extract-plugin
export default {"icon":"darkModeToggle_icon__XCz9D"};